import React from "react";
import { observer } from "mobx-react-lite";

import "./BatchProcessingProgressSnackbar.scss";
import Button from "../button/Button";
import ProgressBarSnackbar from "../progress-bar-snackbar/ProgressBarSnackbar";
import { Info } from "../svg/svgImageList";
import { translationService } from "../../services/translation/TranslationService";
import { batchHighlightDetectionService } from "../../services/batch-processing/BatchHighlightDetectionService";

export default observer(function BatchHighlightDetectionProgressSnackbar() {
  return (
    <div
      className={`batch-processing-progress ${
        batchHighlightDetectionService.statusModel.displaySnackbar ? "show" : "hide"
      }`}
    >
      <div className="info">
        <Button
          className="svg-info"
          icon={{
            svg: Info,
            width: 30,
            height: 30,
          }}
        />
        <span>
          {translationService.translate("damages.BatchProcessingProgress.title", {
            itemsCount: batchHighlightDetectionService.statusModel.videoCount,
          })}
          {translationService.translate("damages.BatchProcessingProgress.title.HighlightDetection")}
        </span>
        <Button
          className={"btn-text"}
          textKey="general.upload.view-details"
          onClick={batchHighlightDetectionService.statusModel.showStatusBatchModal}
        />
      </div>
      <div className="progress-bar-with-stop">
        <ProgressBarSnackbar
          percentComplete={batchHighlightDetectionService.statusModel.percentComplete}
        />
        <span>
          {`${batchHighlightDetectionService.statusModel.successfullyCount} /
            ${batchHighlightDetectionService.statusModel.videoCount}`}
        </span>
      </div>
    </div>
  );
});
